import { ExamMockTestInfo } from './ExamMockTestInfo';

export const ExamMockTest: React.FC = () => {
  return <ExamMockTestInfo />;
};
